<div class="main-card mb-3 card">
  <div class="card-header d-flex justify-content-between align-items-center">
    <span class="font-weight-bold fs-1r">Subscription Plans</span>
    <button class="btn btn-primary" (click)="openAddPlan()">+ Add Plan</button>
  </div>

  <!-- Tabs -->
  <ul class="nav nav-tabs" id="planTabs" role="tablist">
    <li class="nav-item">
      <a
        class="nav-link active"
        id="upto4-tab"
        data-bs-toggle="tab"
        href="#upto4"
        role="tab"
        (click)="getPlans(1, 1)"
      >
        Upto 4 Ton
      </a>
    </li>
    <li class="nav-item">
      <a
        class="nav-link"
        id="above4-tab"
        data-bs-toggle="tab"
        href="#above4"
        role="tab"
        (click)="getPlans(2, 1)"
      >
        4+ Ton
      </a>
    </li>
    <li class="nav-item">
      <a
        class="nav-link"
        id="topup-tab"
        data-bs-toggle="tab"
        href="#topup"
        role="tab"
        (click)="getPlans(3, 1)"
      >
        Top Up
      </a>
    </li>
  </ul>

  <div class="table-responsive">
    <table
      class="align-middle mb-0 table table-borderless table-striped table-hover"
    >
      <thead>
        <tr>
          <th>Plan Name</th>
          <th>Price</th>

          <!-- Validity Days: only for type 2 -->
          <th *ngIf="activePlanType == 2 || activePlanType == 3">Validity Days</th>

          <!-- Khali Gadi Add Post: for all -->
          <th>Khali Gadi Add Post</th>

          <!-- Want Load Contact: only for type 2 & 3 -->
          <th *ngIf="activePlanType == 2 || activePlanType == 3">
            Want Load Contact
          </th>

          <!-- Earning: only for type 1 -->
          <th *ngIf="activePlanType == 1">Earning</th>

          <!-- Online Notification Days: only for type 1 -->
          <th *ngIf="activePlanType == 1">Online Notification</th>

          <th>Tax</th>
          <th>Commission</th>
          <th>Discount</th>
          <th class="text-end">Actions</th>
        </tr>
      </thead>

      <!-- <tbody>
        <tr
          *ngFor="
            let plan of allPlanList
              | paginate
                : {
                    itemsPerPage: itemsPerPage,
                    currentPage: page,
                    totalItems: totalItems
                  }
          "
        >
          <td>{{ plan.planName }}</td>
          <td>{{ plan.price }}</td>
          <td>{{ plan.validityDays }} days</td>
          <td>{{ plan.khaliGadiAddPostDays }}</td>
          <td>{{ plan.earning }}</td>
          <td>{{ plan.onlineNotificationDays }}</td>
          <td>{{ plan.tax }}</td>
          <td>{{ plan.commission }}</td>
          <td>{{ plan.discount }}</td>
         

          <td class="text-end">
            <div class="dropdown">
              <button
                class="btn btn-sm btn-warning dropdown-toggle"
                type="button"
                id="dropdownMenuButton"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Actions
              </button>
              <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                <li>
                  <a class="dropdown-item" (click)="openEditPlan(plan)">Edit</a>
                </li>
                <li>
                  <a
                    class="dropdown-item text-danger"
                    (click)="deleteSubscription(plan)"
                    >Delete</a
                  >
                </li>
              </ul>
            </div>
          </td>
        </tr>
      </tbody> -->

      <tbody>
        <ng-container
          *ngFor="
            let plan of allPlanList
              | paginate
                : {
                    itemsPerPage: itemsPerPage,
                    currentPage: page,
                    totalItems: totalItems
                  }
          "
        >
          <tr *ngIf="plan.planType == activePlanType">
            <td>{{ plan.planName }}</td>
            <td>₹ {{ plan.price }}</td>

            <!-- Validity Days inly for 2 & 3-->
            <td *ngIf="plan.planType == 2">
              {{ plan.validityDays }}
            </td>
            <td *ngIf="plan.planType == 3">
              {{ plan.validityDays == -1 ? "Current Plan" : plan.validityDays }}
            </td>

            <!-- Khali Gadi Add Post Days (for all plan types) -->
            <td>
              <ng-container [ngSwitch]="plan.planType">
                <!-- Type 1: show number + 'days' -->
                <span *ngSwitchCase="1">
                  {{ plan.khaliGadiAddPostDays }} days
                </span>

                <!-- Type 2 & 3: show 'Unlimited' if -1, else number -->
                <span *ngSwitchCase="2">
                  {{
                    plan.khaliGadiAddPostDays == -1
                      ? "Unlimited"
                      : plan.khaliGadiAddPostDays
                  }}
                </span>
                <span *ngSwitchCase="3">
                  {{
                    plan.khaliGadiAddPostDays == -1
                      ? "Unlimited"
                      : plan.khaliGadiAddPostDays
                  }}
                </span>
              </ng-container>
            </td>

            <!-- Want Load Contact (only type 2 & 3 → -1 means Unlimited) -->
            <td *ngIf="plan.planType == 2 || plan.planType == 3">
              {{
                plan.wantLoadContact == -1 ? "Unlimited" : plan.wantLoadContact
              }}
            </td>

            <!-- Earning (only type 1) -->
            <td *ngIf="plan.planType == 1">₹ {{ plan.earning }}</td>

            <!-- Online Notification Days (only type 1) -->
            <td *ngIf="plan.planType == 1">
              {{ plan.onlineNotificationDays }} days
            </td>

            <td>{{ plan.tax }}%</td>
            <td>{{ plan.commission }}%</td>
            <td>{{ plan.discount }}%</td>

            <td class="text-end">
              <div class="dropdown">
                <button
                  class="btn btn-sm btn-warning dropdown-toggle"
                  type="button"
                  data-bs-toggle="dropdown"
                >
                  Actions
                </button>
                <ul class="dropdown-menu">
                  <li>
                    <a class="dropdown-item" (click)="openEditPlan(plan)"
                      >Edit</a
                    >
                  </li>
                  <li>
                    <a
                      class="dropdown-item text-danger"
                      (click)="deleteSubscription(plan)"
                      >Delete</a
                    >
                  </li>
                </ul>
              </div>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
    <ngb-pagination
      (pageChange)="getPlans(activePlanType, (page = $event))"
      [collectionSize]="totalItems"
      [(page)]="page"
      [pageSize]="itemsPerPage"
      [maxSize]="3"
      [rotate]="true"
      [boundaryLinks]="false"
    >
    </ngb-pagination>
  </div>
</div>

<!-- Child modal -->
<app-add-and-edit-subscription-plan
  [subscriptionData]="selectedPlan"
  [showModal]="showModal"
  (closeModal)="handleCloseModal()"
  (save)="handleSave($event)"
></app-add-and-edit-subscription-plan>
